<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">TIMELINE OF MODJESKA’S LIFE AND CAREER</h2>
<table width="100%">
<tbody><tr>
<td style="width:30%" valign="top"><p class="table1">12 October 1840</p></td>
<td style="width:70%" valign="top"><p class="table2">Helena Jadwiga Mizel born to Józefa Bendowa and unknown father in Kraków, Poland. Her half-brothers are Józef, Szymon, and Feliks Benda and, if Micha<span class="fonta">ł</span> Opid is her father, Adolf Opid. Her full (?) sister is Józefa.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">26 April 1848</p></td>
<td valign="top"><p class="table2">Austrian bombardment of Kraków.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">July 1850</p></td>
<td valign="top"><p class="table2">Great Kraków fire, in which the Benda family’s properties are seriously damaged.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">27 January 1861</p></td>
<td valign="top"><p class="table2">Helena gives birth to Rudolf, her son by Gustaw Zimajer.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">July 1861</p></td>
<td valign="top"><p class="table2">The newly named Modrzejewska debuts on the provincial stage in Bochnia. Soon after, her new troupe begins to tour towns in the Austrian partition of Poland.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">10 April 1862</p></td>
<td valign="top"><p class="table2">Helena gives birth to Maria, her daughter by Zimajer. Maria dies in spring 1865.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">November 1862–Spring 1863</p></td>
<td valign="top"><p class="table2">Modrzejewska engaged by the Lwów Theatre.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">January 1863–December 1864</p></td>
<td valign="top"><p class="table2">Polish uprising against the Russian authorities.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">March 1863–August 1865</p></td>
<td valign="top"><p class="table2">Modrzejewska engaged by the Czerniowce Theatre.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">August 1865</p></td>
<td valign="top"><p class="table2">Modrzejewska leaves Zimajer, taking Rudolf with her.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">Fall 1865–Spring 1869</p></td>
<td valign="top"><p class="table2">Modrzejewska engaged by the Kraków Theatre.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">1866</p></td>
<td valign="top"><p class="table2">Zimajer abducts Rudolf. Modrzejewska recovers her son four years later.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">12 September 1868</p></td>
<td valign="top"><p class="table2">Modrzejewska marries Karol Bo<img alt="Image" height="12" src="images/szdot.jpg" width="7"/>enta Ch<span class="fonta">ł</span>apowski.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">October–December 1868</p></td>
<td valign="top"><p class="table2">Modrzejewska debuts successfully at the Warsaw Imperial Theatres.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">Fall 1869–June 1876</p></td>
<td valign="top"><p class="table2">Modrzejewska reigns as prima donna of Warsaw Imperial Theatres.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">13 July 1876</p></td>
<td valign="top"><p class="table2">Modrzejewska’s “colonial party” departs for America.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">20 August 1877</p></td>
<td valign="top"><p class="table2">The renamed Helena Modjeska debuts successfully in San Francisco at the California Theatre.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">22 December 1877</p></td>
<td valign="top"><p class="table2">Modjeska’s first East Coast tour begins in New York.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">October 1879–March 1880</p></td>
<td valign="top"><p class="table2">Modjeska’s return to Poland and first guest tour.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">22 January 1880</p></td>
<td valign="top"><p class="table2">Funeral of Ignacy Neufeld, schoolboy who committed suicide after giving Modjeska a wreath in Polish national colors.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">1 May 1880</p></td>
<td valign="top"><p class="table2">Modjeska’s London debut at the Court Theatre.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">January–March 1882</p></td>
<td valign="top"><p class="table2">Modjeska’s second guest tour in Poland.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">October 1882</p></td>
<td valign="top"><p class="table2">Modjeska returns from England to the American stage.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">October 1884–February 1885</p></td>
<td valign="top"><p class="table2">Modjeska’s third guest tour in Poland.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">Spring 1885</p></td>
<td valign="top"><p class="table2">Modjeska guest tours in England and Ireland.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">28 December 1885</p></td>
<td valign="top"><p class="table2">Ralph Modjeski and Felicja Bendówna marry in New York.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">Summer 1888</p></td>
<td valign="top"><p class="table2">Modjeska and Ch<span class="fonta">ł</span>apowski purchase the Pleasants’ ranch in Southern California and begin transforming it into their American home. They name the ranch Arden.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">Fall 1889–Spring 1890</p></td>
<td valign="top"><p class="table2">Modjeska tours with Edwin Booth.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">Fall 1890–Spring 1891</p></td>
<td valign="top"><p class="table2">Modjeska’s fourth guest tour in Poland.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">19 May 1893</p></td>
<td valign="top"><p class="table2">Modjeska gives nationalist speech at Chicago Columbian Exhibition.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">October 1894–Summer 1895</p></td>
<td valign="top"><p class="table2">Modjeska’s fifth guest tour in Poland. The Russian authorities forbid her appearances in Warsaw in retaliation for her May 1893 speech in Chicago.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">January 1896–November 1897</p></td>
<td valign="top"><p class="table2">Modjeska suffers a stroke and must undergo a long convalescence at Arden.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">July 1901</p></td>
<td valign="top"><p class="table2">Modjeska visits Poland and plays some benefit performances.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">January–April 1903</p></td>
<td valign="top"><p class="table2">Modjeska’s last guest tour of Poland, during which she stars in Wyspia<img alt="Image" height="12" src="images/n.jpg" width="9"/>ski’s <em>Protesilaus and Laodamia</em>.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">2 May 1905</p></td>
<td valign="top"><p class="table2">Modjeska’s benefit held at the Metropolitan Opera House in New York.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">23 August 1906</p></td>
<td valign="top"><p class="table2">Arden is sold and Modjeska and Ch<span class="fonta">ł</span>apowski move to Tustin. They subsequently move to Bay Island in 1908 (present-day Newport, California).</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">8 April 1909</p></td>
<td valign="top"><p class="table2">Modjeska dies in Newport, California.</p></td>
</tr>
<tr>
<td valign="top"><p class="table1">17 July 1909</p></td>
<td valign="top"><p class="table2">Modjeska interred in Kraków’s Rakowicki Cemetery.</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// timeline_of_modjeskas_lifecareer.vue?dfba4b8a